import React from 'react';
import cn from 'classnames';
import './style.css';
import usePagePreferences from '../../hooks/usePagePreferences';

const Title = ({ children, className, ...props }: any) => (
    <h1 {...props} className={cn('view--title', 'shrink mb-8', className)}>
        {children}
    </h1>
);
const InfoHeader = ({ className, ...props }: any) => (
    <header {...props} className={cn('view--info-header', 'bg-grey-50 flex -mt-4 mb-4 w-full px-4 rounded-b', className)} />
);
const InfoBox = ({ className, title, children }: any) => (
    <dl className={cn('mb-0 py-2 w-1/3', className)}>
        <dt className="text-grey-700 text-sm font-normal">{title}</dt>
        <dd className="mb-0 text-xl">{children}</dd>
    </dl>
);
const Header = ({ className, ...props }: any) => (
    <div {...props} className={cn('view--header', 'flex shrink items-center justify-between mb-8', className)} />
);
const HeaderActions = ({ className, ...props }: any) => (
    <div {...props} className={cn('view--header--actions', 'shrink', className)} />
);
const HeaderFilters = ({ className, ...props }: any) => (
    <div {...props} className={cn('view--header--filters', 'shrink pl-4', className)} />
);
const Content = ({ className, ...props }: any) => (
    <div {...props} className={cn('view--content', 'flex flex-col grow shrink', className)} />
);

const View = ({ className, ...props }: any) => (
    <div {...props} className={cn('view', 'flex flex-col h-full w-full', className)} />
);

InfoHeader.Item = InfoBox;

Header.Actions = HeaderActions;
Header.Filters = HeaderFilters;

View.InfoHeader = InfoHeader;
View.Title = Title;
View.Header = Header;
View.Content = Content;

export const useViewFilter = (id?: string): [string, (filter: string) => void, (value: string | number) => boolean] => {
    const [prefs, save] = usePagePreferences();

    const enablePersistance = !!id;
    const key = `filter.${id}`;
    const localFilter = prefs[key] ?? '';
    const initialFilter = enablePersistance ? localFilter : '';

    const [filter, setFilter] = React.useState<string>(initialFilter);
    const filterBy = React.useCallback(
        value => (value ? value.toString().toLowerCase().includes(filter.toLowerCase()) : false),
        [filter]
    );

    const saveAndSetFilter = (filter: string) => {
        setFilter(filter);

        if (enablePersistance) {
            save({ [key]: filter });
        }
    };

    return [filter, saveAndSetFilter, filterBy];
};

export default View;
